import Tenants from '@/lib/Tenants';

export const Locales = [
    { text: 'English', value: 'en' },
    { text: 'Español', value: 'es' },
    { text: 'Русский', value: 'ru' }
];

const LOCAL_STORAGE_LANGUAGE_KEY = 'selectedLanguage';

export const LanguageStorageKey = LOCAL_STORAGE_LANGUAGE_KEY;

export class Locale {
    GetCurrentLocale(): string {
        return this.GetSavedLocale() ?? Tenants.GetCurrentTenantLocale() ?? Locales[0].value;
    }

    GetSavedLocale(): string | null {
        return localStorage.getItem(LOCAL_STORAGE_LANGUAGE_KEY) ?? null;
    }

    SetLocale(locale: string) {
        localStorage.setItem(LOCAL_STORAGE_LANGUAGE_KEY, locale);
    }

    GetFallbackLocale(): string {
        return Locales[0].value;
    }
}

const instance = new Locale();
export default instance;